module.exports = __webpack_public_path__ + "static/media/IMG_6016_2.e79fb64f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/photos/IMG_6016_2.jpg
// module id = 207
// module chunks = 0